module.exports = __webpack_public_path__ + "img/How it Works - We Return1.4c057005.png";